import { Image } from "antd";
import underMaintenanceImage from "../assets/under-maintenance.jpg";
import "./styles.css"; // Make sure the path is correct

export default function UnderMaintenanceMode() {
  return (
    <div className="maintenance-container">
      <div className="maintenance-content">
        <Image 
          alt="404" 
          height={280} 
          src={underMaintenanceImage} 
          width={280} 
          preview={false} 
        />
        
        <span className="maintenance-title">
          Under Maintenance
        </span>

        <div className="maintenance-message-box">
          <div className="maintenance-text">
            Sorry for the inconvenience! Our portal app is currently under
            maintenance to improve your experience.
          </div>
          <div className="maintenance-text">
            Please come back later. Thank you for your patience.
          </div>
        </div>
      </div>
    </div>
  );
}